import React, { Fragment } from "react";
import Table from "react-bootstrap/Table";
import "./prices.scss";
import Paginator from "component/shared/Paginator/Paginator";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { FormattedMessage, useIntl } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import MainDepartment from "component/shared/main-department/MainDepartment";
import { useSelector } from "react-redux";
import HtmlView from "component/htmlView/html-view";
import ReactGA from "react-ga4";

function Prices() {

  const intl = useIntl();

  const currentLocale = useSelector(({ theme }) => theme.locale);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);


  
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/prices", title: "Prices Page" });
  }, []);


  const prices = useSWR({
    url: END_POINTS.API_PRICES,
  });
  const pricesData =
    prices.error ||
    prices.isLoading ||
    prices.data === undefined ||
    prices.data.data === undefined
      ? []
      : prices.data.data;

  function getItemData(items) {
    var res = [];
    var label = "";
    for (let i = 0; i < items.length; i++) {
      for (let j = 0; j < items[i].publications.length; j++) {
        if (label == items[i].title)
          var ob = {
            id: items[i].publications[j].id,
            name: items[i].publications[j].name,
            pricePaper: items[i].publications[j].paperPrice,
            priceCD: items[i].publications[j].cdPrice,
            Translation: items[i].publications[j].publicationTranslations,
            categoryName: items[i].title,
          };
        else {
          var ob = {
            id: null,
            name: null,
            pricePaper: null,
            priceCD: null,
            Translation: items[i].subjectTranslations,
            categoryName: items[i].title,
          };
          res.push(ob);
          var ob = {
            id: items[i].publications[j].id,
            name: items[i].publications[j].name,
            pricePaper: items[i].publications[j].paperPrice,
            priceCD: items[i].publications[j].cdPrice,
            Translation: items[i].publications[j].publicationTranslations,
            categoryName: items[i].title,
          };
          label = items[i].name;
        }
        res.push(ob);
      }
    }
    return res;
  }

  const itemData = getItemData(pricesData);

  var n = 0;
  function setN(x) {
    n = x;
  }

  const renderTable = () => {
    const rendering =
      Object.keys(itemData).length > 0 ? (
        <Table bordered className="prices-table">
          <thead>
            <tr style={{ verticalAlign: "middle" }}>
              <th className="col-16 col-md-0 col-lg">
                <h6>
                  <FormattedMessage id="#" />
                </h6>
              </th>
              <th className="col-16 col-md-9 col-lg">
                <h6>
                  <FormattedMessage id="version-name" />
                </h6>
              </th>
              <th className="col-16 col-md-1 col-lg">
                <center>
                  <h6>
                    <FormattedMessage id="copy-price" />
                  </h6>
                </center>
              </th>
              {/* <th className="col-16 col-md-1 col-lg">
                <center>
                  <h6>
                    <FormattedMessage id="cd-price" />
                  </h6>
                </center>
              </th> */}
              <th className="col-16 col-md-2 col-lg">
                <center>
                  <h6>
                    <FormattedMessage id="digital-version" />
                  </h6>
                </center>
              </th>
            </tr>
          </thead>
          <tbody>
            {/*
                {name!=label?<tr className="table-warning">
                  <td colSpan="5" ><b>{name}</b></td>
                </tr>:<></>
                }

                {changeLabel(name)}
                */}
            <Paginator size={12} table={true}>
              {itemData.map(
                (
                  {
                    id,
                    name,
                    pricePaper,
                    priceCD,
                    Translation,
                    categoryID,
                    categoryName,
                  },
                  i
                ) => (
                  <Fragment key={i}>
                    {id == null ? (
                      categoryName !== itemData[i - 2]?.categoryName ? (
                        <tr className="table-warning">
                          <td colSpan="5">
                            {setN(n - 1)}
                            <b>
                              <LabelLang
                                id="title"
                                defaultValue={categoryName}
                                translations={Translation}
                              />
                            </b>
                          </td>
                        </tr>
                      ) : (
                        <tr className="table-warning d-none">
                          <td colSpan="5">
                            {setN(n - 1)}
                            <b>
                              <LabelLang
                                id="name"
                                defaultValue={categoryName}
                                translations={Translation}
                              />
                            </b>
                          </td>
                        </tr>
                      )
                    ) : (
                      <tr>
                        <td style={{ verticalAlign: "middle" }}>{i + 1 + n}</td>
                        <td style={{ verticalAlign: "middle" }}>
                          <LabelLang
                            id="name"
                            defaultValue={name}
                            translations={Translation}
                          />
                        </td>
                        <td
                          className="text-center"
                          style={{ verticalAlign: "middle" }}
                        >
                          {pricePaper && pricePaper !== 0 ? (
                            pricePaper
                          ) : (
                            <FormattedMessage id="notAvailable" />
                          )}
                        </td>
                        {/* <td
                          className="text-center"
                          style={{ verticalAlign: "middle" }}
                        >
                          {priceCD ? (
                            priceCD
                          ) : (
                            <FormattedMessage id="notAvailable" />
                          )}
                        </td> */}
                        <td>
                          <td>
                            {" "}
                            <a
                              href={`/publications/${id}`}
                              className="main-btn"
                            >
                              <span>
                                {" "}
                                <FormattedMessage id="go-to-bulletin" />
                              </span>
                              <ChevronIcon
                                width={12}
                                height={12}
                                color="#FFFFFF"
                              />
                            </a>
                          </td>
                        </td>
                      </tr>
                    )}
                  </Fragment>
                )
              )}
            </Paginator>
          </tbody>
        </Table>
      ) : (
        <DataNotFound />
      );

    return rendering;
  };

  const getServices = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.PRICES_DEPARTMENT_ID}`,
  });

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${END_POINTS.PRICES_DEPARTMENT_ID}`,
  });

  return (
    <ContentLoading isLoading={getDepartment.isLoading || prices.isLoading}>
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "service-tools" }),
            clickClass: false,
          },
          {
            title: intl.formatMessage({ id: "publication-prices" }),
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "paper-prices" })}
        route={"../servicestools"}
      />
      <div className="container py-5">
        {renderTable()}
        <div className="row mt-5">
          <div className="col-12 col-lg-8">
            {getServices?.data?.data?.content !== null &&
            getServices?.data?.data?.content !== undefined ? (
              <HtmlView
                html={LabelLangString({
                  id: "content",
                  currentLocale: currentLocale,
                  defaultValue: getServices?.data?.data?.content,
                  translations:
                    getServices?.data?.data?.serviceAndToolTranslation,
                })}
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </div>
          <div className="col-12 col-lg-4">
            <MainDepartment getDepartment={getDepartment} />
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Prices;
